exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nspan[data-v-21e9099d] {\n    color: var(--color);\n}\n", ""]);

// exports
